__webpack_require__.p = "/plant-care/";